import { Schema } from 'effect';

import { StringRequired } from './primitive/string';

/**
 * Create Favourite List form data schema
 */
export const CreateFavouritesListFormSchema = Schema.Struct({
  name: StringRequired,
});

export type CreateFavouritesListFormData = Schema.Schema.Type<
  typeof CreateFavouritesListFormSchema
>;
